import { Injectable } from '@angular/core';
import { AbstractService } from '../common/abstract.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServiceErrorHandler } from 'src/app/decorator/service-error-handler-decorator';
import { Observable } from 'rxjs';
import { ContextService } from './context.service';

@Injectable({
  providedIn: 'root'
})
export class IntellegenceService extends AbstractService {

  constructor(private http: HttpClient, private _contextService: ContextService) {
    super();
  }

  uploadMeetingFile(file: any, date: any, headers: any): Observable<any> {
    const formData: any = new FormData();
    formData.append('file', file, file.name);
    formData.append('date', date);
    return this.http.post('/api/iq-intelligence/meeting-notes', formData, {headers: new HttpHeaders(headers)});
  }

  getStakeholderSummary(id: number, redo: boolean = false): Observable<any> {
    return this.http.get(`/api/iq-intelligence/summarize-stakeholder/${id}?reload=${redo}`, this.httpOptions).pipe(
      this._contextService.handleAiAnalysisError()
    );
  }

  @ServiceErrorHandler()
  generateContactMoment(meeting: any): Observable<any> {
    return this.http.post('/api/ai_analysis/generate_contact_moment', meeting, this.httpOptions);
  }

  @ServiceErrorHandler()
  getPoliticalAnalysis(flag: boolean): Observable<any> {
    return this.http.post('/api/iq-intelligence/political', {political_landscape: flag}, this.httpOptions);
  }
  
  @ServiceErrorHandler()
  getRegulatoryAnalysis(flag: boolean): Observable<any> {
    return this.http.post('/api/iq-intelligence/regulatory', {regulatory: flag}, this.httpOptions);
  }
  
  @ServiceErrorHandler()
  getSociologyAnalysis(flag: boolean): Observable<any> {
    return this.http.post('/api/iq-intelligence/sociologic', {sociologic: flag}, this.httpOptions);
  }
  
  @ServiceErrorHandler()
  getAuthoritiesAnalysis(data: any): Observable<any> {
    return this.http.post('/api/iq-intelligence/amenities', data, this.httpOptions);
  }

  @ServiceErrorHandler()
  checkAiCredits(): Observable<any> {
    return this.http.get('/api/iq-intelligence/user-credits', this.httpOptions);
  }
}
